import { EMAIL_TOKENS } from "../../styles/tokens";
import { elementAttributes } from "../html-attributes";
import {
  isBlankColor,
  modelsAlignment,
  parseStyleAttr,
  parseTextAlign,
} from "../html-parse";
import { EMPTY_STYLE_MAP, type StyleMap } from "../shared-block-styles";
import { EmailBlockDefinition } from "../types";

import { LuQuote } from "react-icons/lu";

import { BlockquoteEmailRenderer } from "./email-renderer";
import { BlockquoteTiptapView } from "./tiptap-view";

export interface BlockquoteAttrs extends Record<string, unknown> {
  borderColor: string;
  textAlign: "left" | "center" | "right";
  /** Inline styles as the markup wrote them — the block's style store. */
  style: StyleMap;
  /** Attributes the block does not otherwise model, kept rather than dropped. */
  attributes: Record<string, string>;
}

export const blockquoteBlock: EmailBlockDefinition<BlockquoteAttrs> = {
  name: "emailBlockquote",
  label: "Blockquote",
  icon: LuQuote,
  category: "content",

  schema: {
    attrs: {
      borderColor: { default: EMAIL_TOKENS.colors.brand.primary },
      textAlign: { default: "left" },
      style: { default: EMPTY_STYLE_MAP },
      attributes: { default: {} },
    },
    content: "inline*",
    group: "emailBlock",
    draggable: true,
  },

  parseHTML: () => [
    {
      tag: "blockquote",
      getAttrs: (node) => {
        const el = node as HTMLElement;
        if (!modelsAlignment(el)) return false;
        return {
          textAlign: parseTextAlign(el),
          style: parseStyleAttr(el),
          attributes: elementAttributes(el, ["align"]),
          ...(isBlankColor(el.style.borderLeftColor)
            ? {}
            : { borderColor: el.style.borderLeftColor }),
        };
      },
    },
  ],

  tiptapComponent: BlockquoteTiptapView,
  emailRenderer: BlockquoteEmailRenderer,
};
